import { createAction, props } from '@ngrx/store';

import { IQueryResult } from '@pmis3/data-access';
import { IDateTimeRange } from '@pmis3/core';

import { VesselSchedule, VesselScheduleUpdateBasicDto } from '../';
import { VesselScheduleBerthPlanAssignmentDto } from '../model/vessel-schedule-berth-plan-assignment-dto';

export enum VesselScheduleActionTypes {
    LoadVesselSchedules = '[VesselSchedules Page] Load VesselSchedules',
    LoadVesselSchedulesByDateRange = '[VesselSchedules Page] Load VesselSchedules By Date Range',
    LoadFirstSchedules = '[VesselSchedules Page] Load First VesselSchedules',
    LoadSuccess = '[VesselSchedules Page] Load VesselSchedules Success',
    LoadFail = '[VesselSchedules Page] Load VesselSchedules Fail',
    UpdateBerthPlans = '[VesselSchedules Page] Update Berth Plans',
    UpdateBerthAssignment = '[VesselSchedules Page] Update Berth Assignment',
}

export const LoadVesselSchedules = createAction(
    VesselScheduleActionTypes.LoadVesselSchedules
);

export const LoadVesselSchedulesByDateRange = createAction(
    VesselScheduleActionTypes.LoadVesselSchedulesByDateRange,
    props<{ dateRange: IDateTimeRange }>()
);

export const LoadFirstSchedules = createAction(
    VesselScheduleActionTypes.LoadFirstSchedules,
    props<{ result: string[] }>()
);

export const LoadSuccess = createAction(
    VesselScheduleActionTypes.LoadSuccess,
    props<{ result: IQueryResult<VesselSchedule> }>()
);

export const LoadFail = createAction(
    VesselScheduleActionTypes.LoadFail,
    props<{ error: string }>()
);

export const UpdateBerthPlans = createAction(
    VesselScheduleActionTypes.UpdateBerthPlans,
    props<{ updates: VesselScheduleUpdateBasicDto[] }>()
);

export const UpdateBerthAssignment = createAction(
    VesselScheduleActionTypes.UpdateBerthAssignment,
    props<{ update: VesselScheduleBerthPlanAssignmentDto }>()
);
